import { render, staticRenderFns } from "./comic.vue?vue&type=template&id=2c7db482"
import script from "./comic.vue?vue&type=script&lang=tsx"
export * from "./comic.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports